import { useState, useCallback } from "react";
import { supabase } from "@/integrations/supabase/client";

interface WebshopAccessRow {
  webshop_id: number;
}

export function useWebshopAccess() {
  const [accessibleWebshops, setAccessibleWebshops] = useState<number[]>([]);

  const fetchAccessibleWebshops = useCallback(async (userId: string): Promise<void> => {
    try {
      const { data, error } = await supabase
        .rpc('get_accessible_webshop_ids', { _user_id: userId });
      
      if (data && !error) {
        // Filter out null or invalid webshop IDs
        const validIds = (data as WebshopAccessRow[])
          .map(row => row.webshop_id)
          .filter((id): id is number => id !== null && id !== undefined && !isNaN(id));
        setAccessibleWebshops(validIds);
      } else {
        setAccessibleWebshops([]);
      }
    } catch (error) {
      console.error('[useWebshopAccess] Error fetching webshops:', error);
      setAccessibleWebshops([]);
    }
  }, []);

  return { accessibleWebshops, fetchAccessibleWebshops };
}
